import { POSContact, POSFmiByResource } from './../interfaces/pos-v2';
import { appConfig } from '@/config/app-config';
/* eslint-disable @typescript-eslint/no-explicit-any */
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCApiServiceInstance from '@core/services/bpc-api-service.instance';
import BPCEchoService from '@core/services/bpc-echo.service';
import { POSAccessControlEvent } from '@pos/interfaces/pos-v2';
import { Channel } from 'laravel-echo/dist/channel';

export default class PosAccessControlService {
  protected $routeHelper: BPCApiRouteHelper;
  protected $bpcApi: BPCApiServiceInstance;

  protected $bpcEchoService: BPCEchoService;
  constructor() {
    this.$routeHelper = new BPCApiRouteHelper();
    this.$bpcApi = new BPCApiServiceInstance({ apiPath: appConfig.apiPathV2 });
  }

  get $bpcEcho(): BPCEchoService {
    if (!this.$bpcEchoService) {
      this.$bpcEchoService = new BPCEchoService();
    }
    return this.$bpcEchoService;
  }

  async getAccessControlEvents(PosSessionId: number): Promise<POSAccessControlEvent[]> {
    const path = this.$routeHelper.getApiPath(`pos/${PosSessionId}/access-control-events`);
    const response = await this.$bpcApi.get(path).toPromise();
    return response.data as POSAccessControlEvent[];
  }

  async getFmiByResource(PosSessionId: number): Promise<POSFmiByResource[]> {
    const path = this.$routeHelper.getApiPath(`pos/${PosSessionId}/fmi`);
    const response = await this.$bpcApi.get(path).toPromise();

    return response.data as POSFmiByResource[];
  }
  async getLastContactAccess(PosSessionId: number): Promise<POSContact> {
    const path = this.$routeHelper.getApiPath(`pos/${PosSessionId}/last-contact-access`);
    const response = await this.$bpcApi.get(path).toPromise();
    return response.data as POSContact;
  }

  getAccessControlEventChangesChannel(): Channel {
    return this.$bpcEcho.getAccessControlEventChangesChannel();
  }
  getFmiChangesChannel(): Channel {
    return this.$bpcEcho.getFmiChangesChannel();
  }
}
